/* eslint-disable @typescript-eslint/no-explicit-any */
import cachedAPI from '../api-service/CachedAPIs';
import { referenceDataTypes } from '../reduxExports';
import hwaxios from '../api-service/HWAxios';
import access from '../../auth/service/AccessControl';

const url = process.env.REACT_APP_SERVER_BASE_URL
// const testUrl = process.env.REACT_APP_SERVER_BASE_URL_TEST

export const fetchRegionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/region', 30 * 60 * 60, 'region-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_REGION_REFERENCE_DATA,
            regionReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchStopReasonCodeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const response = await cachedAPI.fetchCacheFunction('/ref/stop-reason-enum-notif', 30 * 60 * 60, 'stop-reason-enum-notif').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
              ...data
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALERT_LOGIC_STOP_REASON_CODE_REF_DATA,
            alertLogicStopReasonCodeRefData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };
    export const fetchChargingHistoryStopReasonCodeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const response = await cachedAPI.fetchCacheFunction('/ref/stop-reason-enum-charging-session', 30 * 60 * 60, 'stop-reason-enum-charging-session').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
              ...data
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CHARGING_HISTORY_STOP_REASON_CODE_REF_DATA,
            chargingHistoryStopReasonCodeReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchSoftwarVersionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {
      try {
        const res = cachedAPI.fetchCacheFunction('/ref/software-version', 30 * 60 * 60, 'software-version-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_SOFTWARE_VERSION_REFERENCE_DATA,
            softwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse)
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchChargerTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/charger-type', 30 * 60 * 60, 'charger-type-data').then((response) => {
          const reduxResponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CHARGER_TYPE_REFERENCE_DATA,
            chargerTypeReferenceData: reduxResponse,
          };
          dispatch(action);
        })
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchCustomerReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {

      try {
        const response = hwaxios.get(url + '/ref/customer').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.customerId,
              value: data?.customerId,
              label: data?.customerName,
              name: data?.customerName,
              customerType: data?.customerType
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CUSTOMER_REFERENCE_DATA,
            customerReferenceData: reduxReponse,
          };
          dispatch(action);

          return JSON.stringify(reduxReponse);

        })
        return response
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchChargerAvailabilityReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/charger-availability', 30 * 60 * 60, 'charger-availability-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CHARGER_AVAILABILITY_REFERENCE_DATA,
        chargerAvailabilityReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchChargerStatusReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/charger-status', 30 * 60 * 60, 'charger-status-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CHARGER_STATUS_REFERENCE_DATA,
        chargerStatusReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAlarmSeverityReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-severity', 30 * 60 * 60, ' alarm-severity-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALARM_SEVERITY_REFERENCE_DATA,
            alarmSeverityReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchConfigureNotificationHistoryRuleIdReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-rule', 30 * 60 * 60, ' alarm-rule-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RULE_ID_CONFIGURE_NOTIFICATION_HISTORY,
            ruleIdConfigurNotificationHistoryReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchAlarmTypeOfNotification: any =
  (allRequired: boolean) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        hwaxios.get(url + `/ref/rule-notification-type?forFilter=${allRequired ?? true}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RULE_TYPE_OF_NOTIFICATION,
            typeOfNotificationReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchChargerModelReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/charger-model', 30 * 60 * 60, 'charger-model-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CHARGER_MODEL_REFERENCE_DATA,
            chargerModelReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };
export const fetchChargerVisibilityReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/visibility-types', 30 * 60 * 60, 'charger-visibility-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CHARGER_VISIBILITY_REFERENCE_DATA,
            chargerVisibilityReferenceData: reduxReponse,

          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchChargerStationReferenceData: any = () =>
  async (
    dispatch: (arg0: Partial<ReferenceDataAction>) => void
  ): Promise<string> => {
    try {
      const response = cachedAPI.fetchCacheFunction('/ref/charging-station', 30 * 60 * 60, 'charging-station-data').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.name + `${data?.dealerCode ? ' - ' + data?.dealerCode: ''}`,
            name: data?.name + + `${data?.dealerCode ? ' - ' + data?.dealerCode: ''}`,
            customerId: data?.customerId
          };
        });

        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_CHARGER_STATION_REFERENCE_DATA,
          chargingStationReferenceData: reduxReponse,
        };
        dispatch(action);
        return JSON.stringify(reduxReponse)
      })
      return response
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

export const fetchChargerLocationReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/ref/location', 30 * 60 * 60, 'charging-location-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data,
          value: data,
          label: data,
          name: data,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CHARGER_LOCATION_REFERENCE_DATA,
        chargerLocationReferenceData: reduxReponse,
      };
      dispatch(action);
    })
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchChargerHistoryTypeReferenceData: any = (reqParams: any) => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    const response = await hwaxios.get(url + `/ref/trend-type?chargerId=${reqParams?.chargerId}`)

    const reduxReponse = response?.data?.data?.data?.historyTypes?.map((data) => {
      return {
        id: data?.id,
        value: data?.name,
        label: data?.name,
        name: data?.name,
        defaultOption: data?.defaultOption,
        statType: data?.statType?.map(statData => ({
          id: statData?.id,
          value: statData?.name,
          label: statData?.name,
          name: statData?.name,
          defaultOption: statData?.defaultOption,
        })),
        connectorType: data?.connectorType?.map(statData => ({
          id: statData?.id,
          value: statData?.name,
          label: statData?.name,
          name: statData?.name,
          defaultOption: statData?.defaultOption,
        }))
      };
    });
    const action: Partial<ReferenceDataAction> = {
      type: referenceDataTypes.FETCH_HISTORY_TYPE_REFERENCE_DATA,
      chargerHistoryTypeReferenceData: reduxReponse,
    };
    dispatch(action);
    return reduxReponse
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchChargerHistoryIntervalReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    const response = await hwaxios.get(url + '/ref/interval-type')

    const reduxReponse = response?.data?.data?.data?.historyInterval?.map((data) => {
      return {
        id: data?.id,
        value: data?.name,
        label: data?.name,
        name: data?.name,
        defaultOption: data?.defaultOption,
        statInterval: data?.statInterval?.map(statData => ({
          id: statData?.id,
          value: statData?.name,
          label: statData?.name,
          name: statData?.name,
          defaultOption: statData?.defaultOption,
        })),
      };
    });
    const action: Partial<ReferenceDataAction> = {
      type: referenceDataTypes.FETCH_HISTORY_INTERVAL_REFERENCE_DATA,
      chargerHistoryIntervalReferenceData: reduxReponse,
    };
    dispatch(action);
    return reduxReponse
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAlarmTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-type', 30 * 60 * 60, ' alarm-type-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALARM_TYPE_REFERENCE_DATA,
            alarmTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchChargerVisibleIdReferenceData: any =
  (reqBody) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const response = await hwaxios.post(url + '/ref/charger-visible-id', reqBody).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.visibleId,
              name: data?.visibleId,
              customerId: data?.customerId,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CHARGER_VISIBLE_ID_REFERENCE_DATA,
            chargerVisibleIdReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse)
        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchChargerVisibleIdsPaginatedList: any =
  (reqBody: { search?: string | null; offset?: number; limit?: number; customerIds?: string[] | null }) =>
    async (): Promise<{ options: { id: string; label: string }[]; hasMore: boolean; totalRowCount: number }> => {
      try {
        const response = await hwaxios.post(url + '/ref/charger-visible-id/list', reqBody);
        return response?.data?.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchUserRoleTypeReferenceData: any =
  (reqParams) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction(`/ref/role?orgId=${reqParams?.orgId}`, 30 * 60 * 60, `user-roleType-data-${reqParams?.orgId}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((item) => {
            return {
              id: item?.id,
              value: item?.id,
              label: item?.name,
              name: item?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_USER_ROLE_TYPE_REFERENCE_DATA,
            userRoleTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const clearUserRoleTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.CLEAR_USER_ROLE_TYPE_REFERENCE_DATA,
          userRoleTypeReferenceData: [], // optionally reset to empty array
        };
        dispatch(action);
      } catch (error) {
        console.error('Error clearing user role type reference data:', error);
        throw error;
      }
    };


export const fetchOrgReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        hwaxios.get(url + '/ref/organization').then((response) => {
          const reduxReponse = response?.data?.data?.map((item) => {
            return {
              id: item?.id,
              value: item?.id,
              label: item?.name,
              name: item?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ORG_REFERENCE_DATA,
            orgReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchParametersReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/params-master', 30 * 60 * 60, 'parameters-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.userName,
              name: data?.userName,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_PARAMETERS_REFERENCE_DATA,
            parametersReferenceData: reduxReponse,
          };
          dispatch(action);
        })

      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchUsersReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        hwaxios.get(url + '/ref/users').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.userName,
              name: data?.userName,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_USERS_REFERENCE_DATA,
            userReferenceData: reduxReponse,
          };
          dispatch(action);
        })

      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchOrgTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/org-types', 30 * 60 * 60, 'org-type-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((item) => {
            return {
              id: item,
              value: item,
              label: item,
              name: item,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ORG_TYPE_REFERENCE_DATA,
            orgTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchRolePermissionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/role/permission/master', 30 * 60 * 60, 'role-permission-data').then((response) => {
          const reduxReponse = response?.data?.data;
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ROLE_PERMISSION_DATA,
            rolePermissionReferenceData: reduxReponse
          }
          dispatch(action);
        });
      }
      catch (error) {
        console.log(error);
        throw error;
      }
    }

export const fetchExceptionLogsSeverityReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/log-severity', 30 * 60 * 60, 'exception-logs-severity').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_EXCEPTION_LOGS_SEVERITY_REFERENCE_DATA,
        exceptionLogsSeverityReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchChargerProductTypeReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/product-type', 30 * 60 * 60, 'charger-product-type-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CHARGER_PRODUCT_TYPE_REFERENCE_DATA,
        chargerProductTypeReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAlarmRules: any = (allRequired: string) => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction(`/ref/rule-alarm-type?forFilter=${allRequired ? allRequired : 'true'}`, 30 * 60 * 60, 'rule-alarm-type').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          severity: data?.severity,
          name: data?.name,
          label: data?.name,
          value: data?.name
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ALARM_TYPES,
        alarmNameReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAlarmRulesExecutionPlan: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/ref/rule-alarm-type-rule-engine', 30 * 60 * 60, 'rule-alarm-type-execution-plan').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          severity: data?.severity,
          name: data?.name,
          label: data?.name,
          value: data?.name
        };
      });
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ALARM_TYPES_EXECUTION_PLAN,
        alarmNameReferenceDataExecutionPlan: reduxReponse,
      };
      dispatch(action);
    })
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchChargerRuleEngineTriggerCategoryReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-trigger', 30 * 60 * 60, 'charger-rule-engine-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_TRIGGER_CATEGORY_REFERENCE_DATA,
        ruleEngineTriggerCategoryReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })
    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchChargerRuleEngineTriggerLevelReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-filter-param', 30 * 60 * 60, 'charger-rule-engine-trigger-level-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_TRIGGER_LEVEL_REFERENCE_DATA,
        ruleEngineTriggerLevelReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchChargerRuleEngineActionControlReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-action', 30 * 60 * 60, 'charger-rule-engine-action-control-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_ACTION_CONTROL_REFERENCE_DATA,
        ruleEngineActionControlReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchChargerRuleEngineScheduleReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-schedule', 30 * 60 * 60, 'charger-rule-engine-schedule-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_SCHEDULE_REFERENCE_DATA,
        ruleEngineScheduleReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchChargerRuleEngineStatusReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-live-status', 30 * 60 * 60, 'charger-rule-engine-status-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_STATUS_REFERENCE_DATA,
        ruleEngineStatusReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchTriggerPoitnParameterConditionData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/rule-engine-param', 30 * 60 * 60, 'rule-engine-param').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
              dataType: data?.dataType,
              ...data
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_TRIGGER_POINT_PARAMETER_CONDITION_REFERENCE_DATA,
            ruleEngineTriggerPointParameterReferenceData: reduxReponse,
          };
          dispatch(action);

        })
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchRuleEngineParamConditionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/rule-engine-param-condition', 30 * 60 * 60, 'rule-engine-param-condition').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
              ...data
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RULE_ENGINE_PARAM_CONDITION,
            ruleEngineParamConditionReferenceData: reduxReponse,
          };
          dispatch(action);

        })
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchRuleEngineParamConditionOperatorReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/rule-engine-operator', 30 * 60 * 60, 'rule-engine-operator').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
              ...data
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RULE_ENGINE_PARAM_OPERATOR,
            ruleEngineParamOperatorReferenceData: reduxReponse,
          };
          dispatch(action);

        })
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchRecipientListReferenceData: any =
  (reqParams) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction(`/ref/recipient/list?orgId=${reqParams?.orgId}`, 30 * 60 * 60, `user-roleType-data-${reqParams?.orgId}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((item) => {
            return {
              id: item?.id,
              value: item?.userName,
              label: item?.userName,
              name: item?.userName,
              ...item
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RULE_ENGINE_ACTION_CONTROL_SEND_NOTIFICATION_RECIPIENT,
            ruleEngineActionControlSendNotificationReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchRuleEngineRaiseATicketCategories: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/rule-engine/ticket-categories', 30 * 60 * 60, '/rule-engine/ticket-categories').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item?.id,
          value: item?.label,
          label: item?.label,
          name: item?.label,
          ...item
        };
      });
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_RAISE_A_TICKET_CATEGORY,
        ruleEngineRaiseATicketCategoryReferenceData: reduxReponseCategory

      }
      dispatch(action)

    });
  } catch (error) {
    console.error(error)
    throw error;
  }
}
export const fetchChargerRuleEngineRuleNameReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rule-list', 30 * 60 * 60, 'charger-rule-engine-rule-name-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.userName,
          name: data?.userName,
        };
      });
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_RULE_NAME_REFERENCE_DATA,
        ruleEngineRuleNameReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchRuleEngineRaiseATicketCallType: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/rule-engine/call-type', 30 * 60 * 60, '/rule-engine/call-type').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item?.id,
          label: item?.name,
          value: item?.name,
          name: item?.name,
          ...item
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_RAISE_A_TICKET_CALL_TYPE,
        ruleEngineRaiseATicketCallTypeReferenceData: reduxReponseCategory

      }
      dispatch(action)

    });
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const fetchRuleEngineRaiseATicketUrgency: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction('/rule-engine/ticket-urgency', 30 * 60 * 60, '/rule-engine/ticket-urgency').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item?.id,
          label: item?.label,
          value: item?.label,
          name: item?.label,
          ...item
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_RAISE_A_TICKET_URGENCY,
        ruleEngineRaiseATicketUrgencyReferenceData: reduxReponseCategory

      }
      dispatch(action)

    });
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const fetchRuleEngineSetParameterParams: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const res = cachedAPI.fetchCacheFunction('/ref/rule-engine-setting-param', 30 * 60 * 60, '/ref/rule-engine-setting-param').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item?.id,
          label: item?.name,
          value: item?.name,
          name: item?.name,
          ...item
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_SET_PARAMETER_PARAM,
        ruleEngineSetParameterParam: reduxReponseCategory

      }
      dispatch(action)

      return JSON.stringify(reduxReponseCategory);

    });
    return res;
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const fetchRuleRemoteCommands: any = (roleId) => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<void> => {
  try {
    cachedAPI.fetchCacheFunction(`/charger/remote-command/master?roleId=${roleId}`, 30 * 60 * 60, '/charger/remote-command/master?roleId').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item.toUpperCase(),
          label: item.toUpperCase(),
          value: item.toUpperCase(),
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RULE_ENGINE_REMOTE_COMMANDS,
        ruleEngineRemoteCommands: reduxReponseCategory

      }
      dispatch(action)

    });
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const fetchAlarmRuleSeverityReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-rule-severity', 30 * 60 * 60, ' alarm-rule-severity-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALARM_RULE_SEVERITY,
            alarmRuleSeverityReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchAllowedCommandsForRole: any =
  (chargerId) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        const response = await hwaxios.get(url + `/charger/remote-command/master?roleId=${access?.fetchRoleId()}&chargerId=${chargerId}`).then((response) => {
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALLOWED_COMMANDS_FOR_ROLE_REFERENCE_DATA,
            allowedCommandsForRoleReferenceData: response?.data?.data,
          };
          dispatch(action);

        });
        return response;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchChargerActiveCertificateReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/charger-cert-type', 30 * 60 * 60, 'charger-active-certificate-type-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CHARGER_ACTIVE_CERTIFICATE_REFERENCE_DATA,
        chargerActiveCertificateReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const fetchResetCounterRemoteCommandRefData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/reset-counter-remote-command', 30 * 60 * 60, 'charger-reset-counter-remote-command-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RESET_COUNTER_REMOTE_COMMAND_REF_DATA,
        resetCounterRemoteCommandReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })
    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchPeripheralCardRefData: any = (reqParam) => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction(`/ref/peripheral-card-types?chargerId=${reqParam?.chargerId}`, 30 * 60 * 60, `charger-peripheral-card-type-ref-data-${reqParam?.chargerId}`).then((response) => {
      const cardTypes = response?.data?.data?.cardTypes?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          name: data?.name,
          label: data?.name,
          selector: data?.selector
        }
      });

      const connectorOptions = response?.data?.data?.connector?.map(data => {
        return {
          id: data?.id,
          value: data?.id,
          name: data?.name,
          label: data?.name
        }
      });

      const smrOptions = response?.data?.data?.smr?.map(data => {
         return {
          id: data?.id,
          value: data?.id,
          name: data?.name,
          label: data?.name
        }
      });

      const reduxResponse = {
        cardTypes,
        connector: connectorOptions,
        smr: smrOptions
      }

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_PERIPHERAL_CARD_REF_DATA,
        peripheralCardReferenceData: reduxResponse
      };
      dispatch(action);
      return JSON.stringify(reduxResponse);
    })
    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchIntervalRangeRefData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/newDashboard/interval-range-ref', 30 * 60 * 60, 'interval-range-data').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_INTERVAL_RANGE_REFERENCE_DATA,
        intervalRangeReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })
    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};



export const fetchVersionSeverityReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/sw-severity', 30 * 60 * 60, 'version-severity-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_SEVERITY_REFERENCE_DATA,
            versionSeverityReferenceData: reduxReponse,
          };
          dispatch(action);
        })


      } catch (error) {
        console.log(error);

        throw error;
      }
    };
export const fetchVersionClassificationReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {

      try {
        cachedAPI.fetchCacheFunction('/ref/sw-classification', 30 * 60 * 60, 'version-classification-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.name,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_CLASSIFICATION_REFERENCE_DATA,
            versionClassificationReferenceData: reduxReponse,
          };
          dispatch(action);
        })


      } catch (error) {
        console.log(error);

        throw error;
      }
    };


export const fetchVersionProductTypeReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/product-type', 30 * 60 * 60, 'charger-product-type-data').then((response) => {
      const reduxResponse = response?.data?.data?.map((data) => {
        return {
          id: data?.name,
          value: data?.name,
          label: data?.name,
          name: data?.name,
        };
      });
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_VERSION_PRODUCT_TYPE_REFERENCE_DATA,
        versionProductTypeReferenceData: reduxResponse,
      };
      dispatch(action);
      return JSON.stringify(reduxResponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchVersionProductSubTypeReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/product-sub-type', 30 * 60 * 60, 'charger-product-sub-type-data').then((response) => {
      const reduxResponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.name,
          label: data?.name,
          name: data?.name,
        };
      });
    const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_VERSION_PRODUCT_SUB_TYPE_REFERENCE_DATA,
        versionReleasesProductSubTypeReferenceData: reduxResponse,
    };
      dispatch(action);
    return JSON.stringify(reduxResponse);
  })
  return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const fetchVersionSwTypeReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    // const response = cachedAPI.fetchCacheFunction('/ref/sw-type', 30 * 60 * 60, 'charger-sw-type-data').then((response) => {
    const response = {
      data:{
        data:[
          {id:'ccu',name:'CCU'},
          {id:'upper',name:'Upper'}
        ]
      }
    }
    const reduxResponse = response?.data?.data?.map((data) => {
      return {
        id: data?.id,
        value: data?.name,
        label: data?.name,
        name: data?.name,
      };
    });
    const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_VERSION_SW_TYPE_REFERENCE_DATA,
        versionReleasesSwTypeReferenceData: reduxResponse,
    };
    dispatch(action);
    return JSON.stringify(reduxResponse);
  // })
  // return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const fetchVersionReleasesSoftwarVersionReferenceData: any =
  (reqBody) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction(`/ref/software-version/product-type?productType=${reqBody?.productType}`, 30 * 60 * 60, `version-releases-software-version-data-${reqBody?.productType}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_RELEASES_SOFTWARE_VERSION_REFERENCE_DATA,
            versionReleasesSoftwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };
export const fetchVersionReleasesDateRangeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/sw-version-intervals', 30 * 60 * 60, 'sw-version-intervals').then((response) => {
          const reduxResponse = response?.data?.data?.map((data) => {
            return {
              id: data.id,
              value: data.id,
              label: data.name,
              name: data.name,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_RELEASES_DATE_RANGE_REFERENCE_DATA,
            versionReleasesDateRangeReferenceData: reduxResponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchAlarmStatusReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-status', 30 * 60 * 60, 'alarm-status-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data.id,
              value: data.id,
              label: data.name,
              name: data.name,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_ALARM_STATE_REFERENCE_DATA,
            alarmStateReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };


export const fetchVersionUpgradeSoftwareVersionsReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction('/ref/sw-version-ftp-url', 30 * 60 * 60, 'sw-version-ftp-url').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data.swVersion,
              value: data.swVersion,
              label: data.swVersion,
              name: data.swVersion,
              ftpUrl: data.ftpUrl,
              productType: data.productType
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_UPGRADE_SOFTWARE_VERSION_REFERENCE_DATA,
            versionUpgradeSoftwareVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchVersionReleasesCustomerReleaseTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction('/ref/sw-version-release-type', 30 * 60 * 60, 'sw-version-release-type').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data.id,
              value: data.id,
              label: data.name,
              name: data.name,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_RELEASES_CUSTOMER_RELEASE_TYPE_REFERENCE_DATA,
            versionReleasesCustomerReleaseTypeReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchCCUVersionReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<any> => {
      try {
        const res = cachedAPI.fetchCacheFunction('/ref/ccu-version', 30 * 60 * 60, 'ccu-version-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_CCU_VERSION_REFERENCE_DATA,
            ccuVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse)
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchVersionReleasesCCUVersionReferenceData: any =
  (reqBody) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<string> => {
      try {
        const res = await cachedAPI.fetchCacheFunction(`/ref/ccu-version/product-type?productType=${reqBody?.productType}`, 30 * 60 * 60, `version-releases-ccu-version-data-${reqBody?.productType}`).then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data,
              value: data,
              label: data,
              name: data,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_VERSION_RELEASES_CCU_VERSION_REFERENCE_DATA,
            versionReleasesCCUVersionReferenceData: reduxReponse,
          };
          dispatch(action);
          return JSON.stringify(reduxReponse);
        });
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    };



export const fetchAISupportSearchPlaceholdersReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        // cachedAPI.fetchCacheFunction('/ref/sw-version-ftp-url', 30 * 60 * 60, 'sw-version-ftp-url').then((response) => {
        const response = {
          status: 200,
          statusText: 'OK',
          data: {
            placeHolders: [
              { 'id': 'b8c2a7b0-5d4a-4e71-8a3d-1e95c71f6a11', 'value': 'Search for anything...' },
              { 'id': 'd2f3a85e-6f30-44c1-8b7c-4a0f74db5f02', 'value': 'Discover something new...' },
              { 'id': 'e7a13f35-0c8b-44f6-a3cc-92e1b9bca933', 'value': 'What are you looking for?' },
              { 'id': 'b4e3a6d1-5c9f-4f82-8a73-2e6f1d3c7b85', 'value': 'Explore trending topics...'},
              { 'id': 'd7c1f9a3-2b8e-42f6-9e31-5c8a1e2b4f76', 'value': 'Start typing to begin your journey...' }
            ]
          }
        }
        const reduxReponse = response?.data?.placeHolders?.map((data) => {
          return {
            id: data.id,
            value: data.value,
          };
        });
        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_AI_SUPPORT_SEARCH_PLACEHOLDERS_REFERENCE_DATA,
          aiSupportSearchPlaceholdersReferenceData: reduxReponse,
        };
        dispatch(action);
      // });
    } catch (error) {
      console.log(error);
      throw error;
    }
    };

export const fetchAISupportSearchKeywordsReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        // cachedAPI.fetchCacheFunction('/ref/sw-version-ftp-url', 30 * 60 * 60, 'sw-version-ftp-url').then((response) => {
        const response = {
          status: 200,
          statusText: 'OK',
          data: {
            placeHolders: [
              { 'id': 'b8c2a7b0-5d4a-4e71-8a3d-1e95c71f6a1f','value': 'Help me find' },
              { 'id': 'a91f64c2-4c9d-41b0-b7f8-51c09f6b5f4d','value': 'How to fix' },
              { 'id': 'd2f3a85e-6f30-44c1-8b7c-4a0f74db5f0e','value': 'Setup' },
              { 'id': 'e2f3a85e-6f31-44c1-8b7c-4a0f74db5f0e','value':'Step-by-Step'},
              { 'id': 'f2d3a85e-6f31-44d1-8b7c-4a0f74db5f0e','value':'Where to configure'},
              { 'id': 'a2f3a85e-6f31-44e1-8b7c-4a0f74db5f0e','value':'Check'},
            ]
          }
        }
        const reduxReponse = response?.data?.placeHolders?.map((data) => {
          return {
            id: data.id,
            name:data.value,
            label:data.value,
            value: data.value,
          };
        });
        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_AI_SUPPORT_SEARCH_KEYWORDS_REFERENCE_DATA,
          aiSupportCenterSearchKeywordsReferenceData: reduxReponse,
        };
        dispatch(action);
      // });
    } catch (error) {
      console.log(error);
      throw error;
    }
    };

export const fetchRmsSupportTroubleshootingAlarmReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/alarm-type', 30 * 60 * 60, ' alarm-type-data').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.name,
              value: data?.name,
              label: data?.name,
              name: data?.name,
            };
          });
          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_RMS_SUPPORT_TROUBLESHOOTING_ALARMS_REF_DATA,
            rmsSupportTroubleshootingAlarmsReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);

        throw error;
      }
    };

export const fetchRmsSupportDocumentVersionReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const response = cachedAPI.fetchCacheFunction('/ref/rms-document-versions', 30 * 60 * 60, 'rms-document-versions').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          value: data?.id,
          label: data?.name,
          name: data?.name,
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_RMS_SUPPORT_DOCUMENT_VERSION_REF_DATA,
        rmsSupportDocumentVersionReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    })

    return response
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAdvanceRuleEngineTriggerParameterReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
try {

  //TODO: Once this api is deployed use the cachedAPI function
  const response = cachedAPI.fetchCacheFunction('/ref/rule-engine-trigger-params', 30 * 60 * 60, 'advance-rule-engine-trigger-params').then((response) => {
  // const response =  hwaxios.get(testUrl + '/ref/rule-engine-trigger-params').then( (response) => {
    const reduxReponse = response?.data?.data?.map((data) => {
      return {
        id: data?.id,
        name: data?.name,
        label: data?.name,
        dataType: data?.dataType,
        fieldType: data?.fieldType,
        unit: data?.unit,
        possibleValue: data?.possibleValue,
        parameterType: data?.parameterType,
        parameterLevel: data?.parameterLevel,
        numberKeyFormat: data?.numberKeyFormat,
        parameterKey: data?.parameterKey,
        acOrDcParam: data?.acOrDcParam
      };
    });

    const action: Partial<ReferenceDataAction> = {
      type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_TRIGGER_PARAM_REF_DATA,
      advanceRuleEngineTriggerParameterReferenceData: reduxReponse,
    };
    dispatch(action);
    return JSON.stringify(reduxReponse);
  });
  return response;
} catch (error) {
  console.log(error);
  throw error;
}
}

export const fetchAdvanceRuleEngineArithmeticOperatorsReferenceData: any =
() =>
  async (
    dispatch: (arg0: Partial<ReferenceDataAction>) => void
  ): Promise<any> => {

    try {
      cachedAPI.fetchCacheFunction('/ref/rule-engine-arithmetic-operator', 30 * 60 * 60, 'rule-engine-arithmetic-operator').then((response) => {
      // hwaxios.get(testUrl + '/ref/rule-engine-arithmetic-operator').then((response)=>{
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.label,
            name: data?.label,
            symbol: data?.symbol
          };
        });

        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_ARITHMETIC_OPERATOR_REF_DATA,
          advanceRuleEngineArithmeticOperatorReferenceData: reduxReponse,
        };
        dispatch(action);

      })
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


export const fetchAdvanceRuleEngineConnectivesReferenceData: any =
() =>
  async (
    dispatch: (arg0: Partial<ReferenceDataAction>) => void
  ): Promise<any> => {

    try {
      cachedAPI.fetchCacheFunction('/ref/rule-engine-operator', 30 * 60 * 60, 'rule-engine-operator').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.name,
            name: data?.name
          };
        });

        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_CONNECTIVES_REF_DATA,
          advanceRuleEngineConnectivesReferenceData: reduxReponse,
        };
        dispatch(action);

      })
    } catch (error) {
      console.log(error);

      throw error;
    }
  };


export const fetchAdvanceRuleEngineRelationalOperatorReferenceData: any =
() =>
  async (
    dispatch: (arg0: Partial<ReferenceDataAction>) => void
  ): Promise<any> => {

    try {
      const symbolMap = {
        equalTo:'=',
        notEqualTo:'!=',
        greaterThan: '>',
        lessThan: '<',
        greaterThanEqualTo: '>=',
        lessThanEqualTo: '<=',
        between:'Between',
        notBetween: 'Not between',
        is: 'Is',
        isNot: 'Is not'
      }

      cachedAPI.fetchCacheFunction('/ref/rule-engine-param-condition', 30 * 60 * 60, 'rule-engine-param-condition').then((response) => {
        const reduxReponse = response?.data?.data?.map((data) => {
          return {
            id: data?.id,
            value: data?.id,
            label: data?.name,
            name: data?.name,
            symbol: symbolMap[data?.id] ?? data?.id
          };
        });

        const action: Partial<ReferenceDataAction> = {
          type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_RELATIONAL_OPERATOR_REF_DATA,
          advanceRuleEngineRelationalOperatorReferenceData: reduxReponse,
        };
        dispatch(action);

      })
    } catch (error) {
      console.log(error);

      throw error;
    }
  };

export const fetchAdvanceRuleEngineRuleNameReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
try {

  //TODO: Once this api is deployed use the cachedAPI function
  const response = cachedAPI.fetchCacheFunction('/ref/rule-list', 30 * 60 * 60, 'rule-list').then((response) => {
  // const response =  hwaxios.get(testUrl + '/ref/rule-list').then( (response) => {
    const reduxReponse = response?.data?.data?.map((data) => {
      return {
        id: data?.id,
        name: data?.name,
        label: data?.name,
        value: data?.id
      };
    });

    const action: Partial<ReferenceDataAction> = {
      type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_RULE_NAME_REF_DATA,
      advanceRuleEngineRuleNameReferenceData: reduxReponse,
    };
    dispatch(action);
    return JSON.stringify(reduxReponse);
  });
  return response;
} catch (error) {
  console.log(error);
  throw error;
}
}

export const fetchCertificateStatusReferenceData: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {

      const response = cachedAPI.fetchCacheFunction('/ref/certificate-status', 30 * 60 * 60, 'certificate-status').then((response) => {
      const reduxReponse = response?.data?.data?.map((data) => {
        return {
          id: data?.id,
          name: data?.name,
          label: data?.name,
          value: data?.id
        };
      });
  
      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_CERTIFICATE_STATUS_REF_DATA,
        certificateStatusReferenceData: reduxReponse,
      };
      dispatch(action);
      return JSON.stringify(reduxReponse);
    });
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
  }

  export const fetchAdvanceRuleEngineSetParameterParams: any = () => async (dispatch: (arg0: Partial<ReferenceDataAction>) => void): Promise<string> => {
  try {
    const res = cachedAPI.fetchCacheFunction('/ref/rule-engine-setting-param', 30 * 60 * 60, '/ref/rule-engine-setting-param').then((response) => {
      const reduxReponseCategory = response?.data?.data?.map((item) => {
        return {
          id: item?.id,
          label: item?.name,
          value: item?.name,
          name: item?.name,
          acOrDc: item?.parameterType == 'ConnectorParameter' ? item?.numberKeyFormat.startsWith('2.5.1.3.') ?'dc' : 'ac' : null,
          ...item
        };
      });

      const action: Partial<ReferenceDataAction> = {
        type: referenceDataTypes.FETCH_ADVANCE_RULE_ENGINE_SET_PARAMETER_PARAM,
        advanceRuleEngineSetParameterParam: reduxReponseCategory

      }
      dispatch(action)

      return JSON.stringify(reduxReponseCategory);

    });
    return res;
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export const fetchInventoryParamChangeLogFieldNameReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/inventory-params/change-logs/field-name', 30 * 60 * 60, 'inventory-params-field-name').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_INVENTORY_PARAM_CHANGE_LOG_FIELD_NAME_REFERENCE_DATA,
            inventoryParamChangeLogFieldNameReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchInventoryParamChangeLogChangeTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/inventory-params/change-logs/change-type', 30 * 60 * 60, 'inventory-params-change-type').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_INVENTORY_PARAM_CHANGE_LOG_CHANGE_TYPE_REFERENCE_DATA,
            inventoryParamChangeLogChangeTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchInventoryParamComponentsReferenceData: any =
  (reqParam) =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
         cachedAPI.fetchCacheFunction(`/ref/inventory-params/components?chargerId=${reqParam?.chargerId}`, 30 * 60 * 60, `inventory-params-field-name-${reqParam?.chargerId}`).then((response) => {
      
          const reduxResponse = [
            {id: 'all', value: 'all', name: 'All', label: 'All', connector: null, smrUnitNo: null, device: null},
            ...response?.data?.data?.map((data) => {
            return {
              id: data?.connector ? `${data?.name} - Connector ${data?.connector}` : data?.smrUnitNo ? `${data?.name} - Unit ${data?.smrUnitNo}` : data?.name,
              value: data?.connector ? `${data?.name} - Connector ${data?.connector}` : data?.smrUnitNo ? `${data?.name} - Unit ${data?.smrUnitNo}` : data?.name,
              label: data?.connector ? `${data?.name} - Connector ${data?.connector}` : data?.smrUnitNo ? `${data?.name} - Unit ${data?.smrUnitNo}` : data?.name,
              name: data?.connector ? `${data?.name} - Connector ${data?.connector}` : data?.smrUnitNo ? `${data?.name} - Unit ${data?.smrUnitNo}` : data?.name,
              connector: data?.connector,
              smrUnitNo: data?.smrUnitNo,
              device: data?.name
            };
          }) ?? []];

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_INVENTORY_PARAM_COMPONENTS_REFERENCE_DATA,
            inventoryParamComponentsReferenceData: reduxResponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const fetchInventoryParamComponentTypeReferenceData: any =
  () =>
    async (
      dispatch: (arg0: Partial<ReferenceDataAction>) => void
    ): Promise<void> => {
      try {
        cachedAPI.fetchCacheFunction('/ref/inventory-params/component-type', 30 * 60 * 60, 'inventory-params-component-type').then((response) => {
          const reduxReponse = response?.data?.data?.map((data) => {
            return {
              id: data?.id,
              value: data?.id,
              label: data?.name,
              name: data?.name,
            };
          });

          const action: Partial<ReferenceDataAction> = {
            type: referenceDataTypes.FETCH_INVENTORY_PARAM_COMPONENT_TYPE_REFERENCE_DATA,
            inventoryParamComponentTypeReferenceData: reduxReponse,
          };
          dispatch(action);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

export const getRmsAlertDetails: any = async () => {
  try {
    const response = await hwaxios.get(url + '/rms-alert');
    if (response?.status === 200 || response?.status === 201) {
      return { status: 'SUCCESS', data: response?.data?.data };
    } else {
      return { status: 'FAILURE' };
    }
  } catch (err) {
      console.error(err);
      return { status: 'FAILURE' };
  }
}